import React, { useRef, useEffect } from "react";
import Chart from "chart.js";
import { PieChartDummyData } from "./dummyData/SingleDummyData";
import { Box } from "@material-ui/core";

/**
 * PieChart
 * @param {*} labels labels
 * @param {*} datasets datasets
 * @returns
 */
const PieChart = ({
  labels = PieChartDummyData.labels,
  datasets = PieChartDummyData.datasets,
}) => {
  const canvasRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    try {
      const ctx = canvasRef.current.getContext("2d");
      if (chartInstanceRef.current) {
        chartInstanceRef.current.stop();
        chartInstanceRef.current.destroy();
      }
      labels = JSON.parse(JSON.stringify(labels));
      datasets = JSON.parse(JSON.stringify(datasets));

      chartInstanceRef.current = new Chart(ctx, {
        type: "pie",
        data: {
          labels: labels,
          datasets: datasets,
        },
        options: {
          animation: {
            duration: 250,
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: true,
            position: "right",
            labels: {
              generateLabels: (chart) => {
                try {
                  return chart.data.labels.map((label, index) => {
                    const dataset = chart.data.datasets[0];
                    const value = dataset.data[index];
                    const subData = dataset.subData[index];
                    const unit = dataset.unit ?? "";
                    return {
                      text: `${label} (${isNaN(value) ? 0 : value}% ${
                        (isNaN(subData) ? 0 : subData) + unit
                      })`,
                      fillStyle: dataset.backgroundColor[index],
                      strokeStyle: "#fff",
                      lineWidth: 1,
                      hidden: false,
                    };
                  });
                } catch (e) {
                  console.error(e);
                  return [];
                }
              },
            },
          },
          tooltips: { enabled: false },
          plugins: {
            datalabels: { display: false },
            outlabels: { display: false },
          },
        },
      });
    } catch (e) {
      console.error(e);
    }

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.stop();
        chartInstanceRef.current.destroy();
      }
    };
  }, [labels, datasets]);

  return (
    <Box style={{ width: "100%", height: "100%" }}>
      <canvas ref={canvasRef} />
    </Box>
  );
};

export default PieChart;
